<template>
  <div class="order-kpi">
    <table class="table is-fullwidth" style="margin:0;padding:0">
      <thead>
        <tr>
          <th width="100">KPI</th>
          <th>EXPECTED</th>
          <th>ACTUAL</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th>START</th>
          <td class="no-wrap">
            <div class="columns is-vcentered">
              <div class="column is-6">
                <div v-if="order.requiredStart">
                  {{ order.requiredStart | toLocalDateAndTime | uppercase }}
                </div>
              </div>
              <div class="column is-6">

                <order-kpi-appeal
                  :order="order"
                  type="start"
                  v-if="order.actualStart"
                />

                <order-kpi-date-change :order="order" type="start" v-else />

              </div>
            </div>
          </td>
          <td>
            <div class="columns is-vcentered" v-if="order.actualStart">

              <div class="column is-6">

                  <p style="margin-top:5px;">

                    {{ order.actualStart | toLocalDateAndTime | uppercase }}

                   <b-tooltip :label="'Started using '+ order.started_via_app.source +' by ' + order.started_via_app.user" 

                   position="is-top" 
      
                   type="is-dark"
                   
                   multilined 

                   v-if="order.started_via_app"

                  style="position: absolute; margin-left: 10px;margin-top: -6px;">

                    <span class="fa fa-mobile" style="font-size:30px;"></span>

                  </b-tooltip>

                  </p>

              </div>

            </div>
            <div class="columns" v-else>
              <div class="column is-6">
                <b-datetimepicker
                  :datetime-formatter="dateFormatter"
                  icon="calendar"
                  v-model="actualStart"
                  :disabled="!order.editable"
                  v-if="
                    canBeStarted &&
                      canBeStarted.value &&
                      canBeStartedByUser &&
                      canBeStartedByUser.value
                  "
                />
              </div>
              <div class="column is-6">
                <b-button
                  id="start_order"
                  type="is-success"
                  class="is-fullwidth has-text-weight-bold"
                  :loading="starting"
                  :disabled="(canBeStarted && !canBeStarted.value) || !order.editable"
                  @click="start"
                  :title="
                    !canBeStarted.value
                      ? canBeStarted && canBeStarted.help[0]
                      : ''
                  "
                  v-if="canBeStartedByUser && canBeStartedByUser.value"
                  >START</b-button
                >
              </div>
            </div>
          </td>
        </tr>
        <tr
          v-if="order.orderTypeCode && order.orderTypeCode.code === 'REACTIVE'"
        >
          <th>MADE SAFE</th>
          <td>N/A</td>
          <td :class="{ 'no-wrap': !!order.madeSafe }">
            <span v-if="order.madeSafe">
              {{ order.madeSafe | toLocalDateAndTime | uppercase }}
            </span>
            <div class="columns" v-else>
              <div class="column is-6">
                <b-datetimepicker
                  :datetime-formatter="dateFormatter"
                  icon="calendar"
                  v-model="actualMadeSafe"
                  :disabled="!order.editable"
                  v-if="
                    canBeMadeSafe &&
                      canBeMadeSafe.value &&
                      canBeMadeSafeByUser &&
                      canBeMadeSafeByUser.value
                  "
                />
              </div>
              <div class="column is-6">
                <b-button
                  id="made-safe-order"
                  type="is-info"
                  class="is-fullwidth has-text-weight-bold"
                  :loading="madeSafing"
                  :disabled="(canBeMadeSafe && !canBeMadeSafe.value) || !order.editable"
                  @click="madeSafe"
                  :title="
                    !canBeMadeSafe.value
                      ? canBeMadeSafe && canBeMadeSafe.help[0]
                      : ''
                  "
                  v-if="canBeMadeSafeByUser && canBeMadeSafeByUser.value"
                  >MADE SAFE</b-button
                >
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <th>FINISH</th>
          <td class="no-wrap">
            <div class="columns is-vcentered">
              <div class="column is-6">
                <div v-if="order.requiredFinish">
                  {{ order.requiredFinish | toLocalDateAndTime | uppercase }}
                </div>
                
              </div>
              <div class="column is-6">
                <order-kpi-appeal
                  :order="order"
                  type="finish"
                  v-if="order.actualFinish"
                />
                <order-kpi-date-change :order="order" type="finish" v-else />
              </div>
            </div>
          </td>
          <td>
            <div class="columns is-vcentered" v-if="order.actualFinish">

              <div class="column is-6">

                <p style="margin-top:5px;">

                  {{ order.actualFinish | toLocalDateAndTime | uppercase }}

                 <b-tooltip :label="'Stopped using '+ order.stopped_via_app.source +' by ' + order.stopped_via_app.user" 
                 
                 position="is-top" 

                 multilined 

                 type="is-dark"

                 v-if="order.stopped_via_app"

                 style="position: absolute; margin-left: 10px;margin-top: -6px;">
          
                  <span class="fa fa-mobile" style="font-size:30px;"></span>

                  <!-- <span class="fa fa-apple" style="font-size:30px; color:#ff3860;" v-if="order.stopped_via_app.source == 'ios'"></span>

                  <span class="fa fa-android" style="font-size:30px; color:#ff3860;" v-else></span> -->

                </b-tooltip>

                </p>


              </div>

            </div>
            <div class="columns" v-else>
              <div class="column is-6">
                <b-datetimepicker
                  :datetime-formatter="dateFormatter"
                  icon="calendar"
                  v-model="actualFinish"
                  v-if="
                    canBePhysicallyCompleted &&
                      canBePhysicallyCompleted.value &&
                      canBePhysicallyCompletedByUser &&
                      canBePhysicallyCompletedByUser.value
                  "
                />
              </div>
              <div class="column is-6">
                <b-button
                  id="finish_order"
                  type="is-danger"
                  class="is-fullwidth has-text-weight-bold"
                  :loading="finishing"
                  :disabled="(canBePhysicallyCompleted && !canBePhysicallyCompleted.value) || !order.editable"
                  @click="finish"
                  :title="
                    !canBePhysicallyCompleted.value
                      ? canBePhysicallyCompleted &&
                        canBePhysicallyCompleted.help[0]
                      : ''
                  "
                  v-if="
                    canBePhysicallyCompletedByUser &&
                      canBePhysicallyCompletedByUser.value
                  "
                >
                  FINISH
                </b-button>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import moment from "moment";
import OrderKpiAppeal from "@/components/OrderKpi/OrderKpiAppeal";
import OrderKpiDateChange from "@/components/OrderKpi/OrderKpiDateChange";
import { OrderService } from "@/services/order.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";
import { ConfigurationValidator } from "@/helpers/ConfigurationValidator";

export default {
  orderService: OrderService,
  props: {
    order: {
      required: true
    }
  },
  components: {
    OrderKpiAppeal,
    OrderKpiDateChange
  },
  data() {
    return {
      actualStart: null,
      actualFinish: null,
      actualMadeSafe: null,
      starting: false,
      madeSafing: false,
      finishing: false
    };
  },
  computed: {
    user() {
      return this.$store.state.Auth.user;
    },
    canBeStarted() {
      return this.$store.getters["OrderState/getStateByKey"]("can_be_started");
    },
    canBeStartedByUser() {
      return this.$store.getters["OrderState/getStateByKey"](
        "can_be_started_by_user"
      );
    },
    canBeMadeSafe() {
      return this.$store.getters["OrderState/getStateByKey"](
        "can_be_made_safe"
      );
    },
    canBeMadeSafeByUser() {
      return this.$store.getters["OrderState/getStateByKey"](
        "can_be_made_safe_by_user"
      );
    },
    canBePhysicallyCompleted() {
      return this.$store.getters["OrderState/getStateByKey"](
        "can_be_physically_completed"
      );
    },
    canBePhysicallyCompletedByUser() {
      return this.$store.getters["OrderState/getStateByKey"](
        "can_be_physically_completed_by_user"
      );
    }
  },
  created() {
    this.setDates();
  },
  watch: {
    order() {
      this.setDates();
    }
  },
  methods: {
    setDates() {
      this.actualStart = this.order.actualStart
        ? new Date(this.order.actualStart)
        : new Date();
      this.actualMadeSafe = new Date();
      this.actualFinish = new Date();
    },
    dateFormatter(date) {
      return moment(date).format("DD/MM/YYYY HH:mm");
    },
    dateParser(date) {
      return moment(date)
        .tz(moment.tz.guess())
        .format();
    },
    async start() {
      this.starting = true;

      try {
        const order = await this.$options.orderService
          .start(this.order.id, {
            started_at: this.dateParser(this.actualStart),
            includes: "state"
          })
          .then(response => JsonDenormalizer.denormalize(response.data));

        this.order.status = order.status;
        this.order.actualStart = order.actualStart;
        this.order.kpiStart = order.kpiStart;

        // Set order state
        this.$store.commit("OrderState/SET_STATE", order.state);

        this.$buefy.toast.open({
          message: "Order has been started.",
          type: "is-info",
          position: "is-top-right"
        });
      } catch (err) {
        window.console && console.log(err);
      }

      this.starting = false;
    },
    async madeSafe() {
      this.madeSafing = true;

      try {
        const order = await this.$options.orderService
          .madeSafe(this.order.id, {
            safe_at: this.dateParser(this.actualMadeSafe),
            includes: "state"
          })
          .then(response => JsonDenormalizer.denormalize(response.data));

        this.order.status = order.status;
        this.order.madeSafe = order.madeSafe;

        // Set order state
        this.$store.commit("OrderState/SET_STATE", order.state);

        this.$buefy.toast.open({
          message: "Order has been made safe.",
          type: "is-info",
          position: "is-top-right"
        });
      } catch (err) {
        window.console && console.log(err);
      }

      this.madeSafing = false;
    },
    async finish() {
      this.finishing = true;

      try {
        const order = await this.$options.orderService
          .finish(this.order.id, {
            finished_at: this.dateParser(this.actualFinish),
            includes: "state"
          })
          .then(response => JsonDenormalizer.denormalize(response.data));

        this.order.status = order.status;
        this.order.madeSafe = order.madeSafe;
        this.order.actualFinish = order.actualFinish;
        this.order.kpiFinish = order.kpiFinish;

        // Set order state
        this.$store.commit("OrderState/SET_STATE", order.state);

        this.$buefy.toast.open({
          message: "Order has been finished.",
          type: "is-info",
          position: "is-top-right"
        });
      } catch (err) {
        window.console && console.log(err);
      }

      this.finishing = false;
    }
  }
};
</script>

<style lang="scss">
.order-kpi {
  .datepicker {
    word-break: initial;
  }
  .table {
    table-layout: fixed;
  }
  .kpi-btn {
    padding-top: 0.5px;
    padding-bottom: 0.5px;

    .kpi-btn-text {
      font-size: 8px;
      width: min-content;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/OrderKpi/OrderKpi.vue